var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 1C0.25 0.585786 0.585786 0.25 1 0.25H19C19.4142 0.25 19.75 0.585786 19.75 1C19.75 1.41421 19.4142 1.75 19 1.75H1C0.585786 1.75 0.25 1.41421 0.25 1ZM0.25 5C0.25 4.58579 0.585786 4.25 1 4.25H19C19.4142 4.25 19.75 4.58579 19.75 5C19.75 5.41421 19.4142 5.75 19 5.75H1C0.585786 5.75 0.25 5.41421 0.25 5ZM0.25 9C0.25 8.58579 0.585786 8.25 1 8.25H9C9.41421 8.25 9.75 8.58579 9.75 9C9.75 9.41421 9.41421 9.75 9 9.75H1C0.585786 9.75 0.25 9.41421 0.25 9ZM15.0119 9.43056C15.2928 9.18981 15.7072 9.18981 15.9881 9.43056L19.4881 12.4306C19.8026 12.7001 19.839 13.1736 19.5694 13.4881C19.2999 13.8026 18.8264 13.839 18.5119 13.5694L15.5 10.9878L12.4881 13.5694C12.1736 13.839 11.7001 13.8026 11.4306 13.4881C11.161 13.1736 11.1974 12.7001 11.5119 12.4306L15.0119 9.43056ZM0.25 13C0.25 12.5858 0.585786 12.25 1 12.25H9C9.41421 12.25 9.75 12.5858 9.75 13C9.75 13.4142 9.41421 13.75 9 13.75H1C0.585786 13.75 0.25 13.4142 0.25 13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/Documents.ade5f9ad5a8bfffc98a5c89787a0be90.svg";
export { ForwardRef as ReactComponent };